import { httpClient } from "@/services";
import getClonedObject from "@/helper/getClonedObject";
import getSetting from "@/helper/getSetting";

export default {
	state: {
		settingsDefault: [],
		settings: [],
		settingsHeaders: [],
		settingsOptions: {},
	},
	mutations: {
		updateSettingsOptions(state, payload) {
			state.settingsOptions = {
				...state.settingsOptions,
				...payload,
			};
		},
		updateResetSettingsState(state) {
			state.settingsDefault = [];
			state.settings = [];
			state.settingsHeaders = [];
			state.settingsOptions = {};
		},
		updateSettings(state, { settings, key, defaultHeader }) {
			getSetting(state, settings, key, defaultHeader);
		},
		updateSettingsAll(state, payload) {
			state.settings = state.settings.map(item => {
				item.settings = payload;
				return item;
			});
		},
		updateDragSettings(state, payload) {
			state.settings = payload;
		},
		updateSettingsReset(state) {
			state.settings = getClonedObject(state.settingsDefault);
		},
	},
	actions: {
		doSettingsSetOptions({ commit }, payload) {
			commit('updateSettingsOptions', payload);
		},
		doDragSettings({ commit }, settings) {
			commit('updateDragSettings', settings);
		},
		onResetSettingsState({ commit }) {
			commit('updateResetSettingsState');
		},
		doSettingsAll({ commit }, payload) {
		  commit('updateSettingsAll', payload);
	  },
		doSettingsReset({ commit }) {
		  commit('updateSettingsReset');
	  },
		async doSettingsSave({ dispatch, state }, key) {
			dispatch("actionPreloader", true);
			try {
				const limitFromOptions = state.settingsOptions.limit;
				const limitFromSettings = Array.isArray(state.settings)
					? state.settings.find(item => item && item.limit != null)?.limit
					: null;

				const currentLimit = limitFromOptions != null ? limitFromOptions : limitFromSettings;

				const settings = Array.isArray(state.settings)
					? state.settings.map(item => ({
						...item,
						...(currentLimit != null ? { limit: currentLimit } : {}),
					}))
					: [];

				await httpClient.post(`/${ key }/settings`, { settings });
			} catch (e) {
				console.error(e);
			} finally {
				dispatch("actionPreloader", false);
			}
		},
	},
	getters: {
		settingsDefault: s => s.settingsDefault,
		settings: s => s.settings,
		settingsHeaders: s => s.settingsHeaders,
		settingsOptions: s => s.settingsOptions,
	}
};
